import { Link } from "react-router";
import { site, type Language } from "../config/site";
import { supportContent } from "../content/support";

export function SupportPage({ language }: { language: Language }) {
  const copy = supportContent[language];
  const prefix = language === "tr" ? "/tr" : "";
  return (
    <div className="support-page marketing-width">
      <header className="page-hero">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1>{copy.title}</h1>
        <p>{copy.introduction}</p>
      </header>
      <section className="support-grid" aria-label={language === "tr" ? "Sık sorulan sorular" : "Frequently asked questions"}>
        {copy.items.map((item, index) => (
          <article key={item.question}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <div><h2>{item.question}</h2>{item.answer.map((answer) => <p key={answer}>{answer}</p>)}</div>
          </article>
        ))}
      </section>
      <aside className="contact-card">
        <div><p className="eyebrow">{site.email}</p><h2>{copy.contactTitle}</h2><p>{copy.contactBody}</p></div>
        <a className="button button--primary" href={`mailto:${site.email}`}>{copy.contactAction}</a>
      </aside>
      <div className="legal-crosslinks">
        <Link to={`${prefix}/privacy/`}>{language === "tr" ? "Gizlilik Politikası" : "Privacy Policy"}</Link>
        <Link to={`${prefix}/terms/`}>{language === "tr" ? "Kullanım Koşulları" : "Terms of Use"}</Link>
      </div>
    </div>
  );
}
